module.exports = "/images/cooper-2.jpg";